import React from 'react';
import {Link} from "react-router-dom";
import {ReactComponent as ArrowRightIco} from "../../../../images/icons/arrow-right.svg";
import {useTranslation} from "react-i18next";

interface Props {
    addressFullString?: string;
}

const DrawerMultiStoreSection = ({addressFullString}: Props) => {
    const {t} = useTranslation();

    return (
        <>
            {
                addressFullString && (
                    <ul className="navbar-nav justify-content-end flex-grow-1">
                        <li className={"nav-item"}>
                            <Link className="nav-link" to={`/`}>
                                <div className={"nav-link-multiline"}>
                                    <small>{t("modules.navbar.action.change_restaurant.title")}</small>
                                    {addressFullString}
                                </div>
                                <ArrowRightIco/>
                            </Link>
                        </li>
                    </ul>
                )
            }
        </>
    )
}

export default DrawerMultiStoreSection;